/* 스폰서 구역 미리보기 (/ds/sponsored)
 *
 * 실제 화면에는 광고 데이터 소스가 아직 없어 아무것도 그려지지 않습니다.
 * 붙었을 때 어떻게 보이는지 여기서 확인합니다. 가짜 데이터는 이 파일에만 둡니다.
 */
import { AppScreen, Section, SectionHeader, ListCard } from 'components/ds';
import { SponsoredPlaces, SponsoredPlace } from 'components/meeting/SponsoredPlaces';

const RECOMMENDED = [
    { id: 'r1', name: '의왕 김치찌개', meta: '음식점 · 4.5 · 여기서 420m', why: '지영·민수와 2번' },
    { id: 'r2', name: '무공돈까스 의왕포일점', meta: '음식점 · 4.4 · 여기서 1.2km', why: '어제 방문' },
    { id: 'r3', name: '행복플러스카페', meta: '카페 · 4.8 · 여기서 52m', why: '오후 9시까지' },
];

const SPONSORED: SponsoredPlace[] = [
    { id: 's1', name: '화통삼 의왕점', meta: '음식점 · 여기서 700m', pitch: '첫 방문 시 음료 서비스' },
    { id: 's2', name: '더테이블한정식', meta: '음식점 · 여기서 90m', pitch: '단체석 예약 가능' },
];

export const SponsoredPreview = () => (
    <AppScreen title="스폰서 구역" bar="sub">
        <Section spacing="tight">
            <SectionHeader
                title="근처에서 평이 좋은 곳"
                sub="추천은 왜 이 가게인지를 말할 수 있어야 합니다"
            />
            {RECOMMENDED.map(p => (
                <ListCard key={p.id} title={p.name} sub={p.meta} evidence={p.why} />
            ))}

            {/* 추천이 끝난 뒤에만 광고가 옵니다 */}
            <SponsoredPlaces places={SPONSORED} />
        </Section>

        <Section divided last>
            <SectionHeader title="데이터가 없을 때" sub="아무것도 그리지 않습니다" />
            <SponsoredPlaces places={[]} />
        </Section>
    </AppScreen>
);
